import { fetchWithTokenAndRegion } from '@adsk/acs-sc-web-platform-api';

export const fetchWithAccountType = <T>(
  url: RequestInfo,
  fetchData?: RequestInit,
): Promise<T> =>
  fetchWithTokenAndRegion(url, {
    ...fetchData,
    headers: {
      ...fetchData?.headers,
      // This is a temporary fix for adding the accountType key to the response, for more information see: https://autodesk.atlassian.net/wiki/x/ZNsuHg
      'x-include': 'account_type, accountType',
    },
  });
